export default __webpack_public_path__ + "static/suppscomingsoon-084147b71536ab48c803914e825595fd.jpg";